// Food SVG Icons for BIGGUYS website

export const DrumstickIcon = ({ className = '', size = 100, color = '#E4002B' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="35" cy="35" rx="28" ry="25" fill={color} />
    <ellipse cx="35" cy="35" rx="28" ry="25" fill="url(#drumstick-gradient)" />
    <rect x="50" y="48" width="45" height="12" rx="6" transform="rotate(35 50 48)" fill="#F5DEB3" />
    <rect x="52" y="50" width="40" height="8" rx="4" transform="rotate(35 52 50)" fill="#DEB887" />
    <ellipse cx="30" cy="28" rx="8" ry="5" fill="rgba(255,255,255,0.3)" />
    <defs>
      <linearGradient id="drumstick-gradient" x1="10" y1="10" x2="60" y2="60" gradientUnits="userSpaceOnUse">
        <stop stopColor={color} />
        <stop offset="1" stopColor="#8B0000" />
      </linearGradient>
    </defs>
  </svg>
  // <img src="drumstick.png" height={size} className={`hero-drumstick ${className}`} alt="Drumstick" />

)

export const WingsIcon = ({ className = '', size = 100, color = '#E4002B' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 50C20 35 30 25 50 25C70 25 80 35 80 50C80 65 70 75 50 75C30 75 20 65 20 50Z" fill={color} />
    <path d="M20 50C20 35 30 25 50 25C70 25 80 35 80 50C80 65 70 75 50 75C30 75 20 65 20 50Z" fill="url(#wings-gradient)" />
    <path d="M25 45C25 38 32 32 45 32" stroke="rgba(255,255,255,0.4)" strokeWidth="3" strokeLinecap="round" />
    <circle cx="35" cy="55" r="3" fill="#8B0000" />
    <circle cx="50" cy="58" r="3" fill="#8B0000" />
    <circle cx="65" cy="55" r="3" fill="#8B0000" />
    <defs>
      <linearGradient id="wings-gradient" x1="20" y1="25" x2="80" y2="75" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF6B6B" />
        <stop offset="1" stopColor={color} />
      </linearGradient>
    </defs>
  </svg>
)

export const BurgerIcon = ({ className = '', size = 100 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Top bun */}
    <path d="M15 45C15 30 25 20 50 20C75 20 85 30 85 45H15Z" fill="#D2691E" />
    <path d="M20 40C20 32 30 25 50 25C70 25 80 32 80 40" stroke="#F4A460" strokeWidth="2" />
    {/* Sesame seeds */}
    <ellipse cx="35" cy="30" rx="3" ry="2" fill="#FFFACD" />
    <ellipse cx="50" cy="28" rx="3" ry="2" fill="#FFFACD" />
    <ellipse cx="65" cy="30" rx="3" ry="2" fill="#FFFACD" />
    {/* Lettuce */}
    <path d="M12 48C12 48 25 52 50 52C75 52 88 48 88 48C88 48 75 55 50 55C25 55 12 48 12 48Z" fill="#228B22" />
    {/* Patty */}
    <rect x="15" y="55" width="70" height="12" rx="3" fill="#8B4513" />
    {/* Cheese */}
    <path d="M12 55L18 62H82L88 55H12Z" fill="#FFD700" />
    {/* Bottom bun */}
    <path d="M15 67H85C85 77 75 82 50 82C25 82 15 77 15 67Z" fill="#D2691E" />
  </svg>
)

export const ChiliIcon = ({ className = '', size = 60 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30 55C20 55 12 45 12 30C12 15 20 8 30 8C35 8 38 10 38 10C38 10 35 5 30 5C28 5 26 6 26 6C26 6 28 3 32 3C38 3 42 8 42 8C44 10 48 15 48 30C48 45 40 55 30 55Z" fill="#E4002B" />
    <path d="M30 50C23 50 18 42 18 30C18 18 23 12 30 12" stroke="rgba(255,255,255,0.3)" strokeWidth="2" strokeLinecap="round" />
    <path d="M30 5C30 5 32 2 34 2C36 2 38 4 38 4" stroke="#228B22" strokeWidth="3" strokeLinecap="round" />
  </svg>
)

export const FireIcon = ({ className = '', size = 60 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30 5C30 5 15 20 15 35C15 48 22 55 30 55C38 55 45 48 45 35C45 20 30 5 30 5Z" fill="url(#fire-gradient)" />
    <path d="M30 25C30 25 22 32 22 40C22 48 26 52 30 52C34 52 38 48 38 40C38 32 30 25 30 25Z" fill="#FFD700" />
    <path d="M30 35C30 35 26 38 26 43C26 48 28 50 30 50C32 50 34 48 34 43C34 38 30 35 30 35Z" fill="#FFF" />
    <defs>
      <linearGradient id="fire-gradient" x1="30" y1="5" x2="30" y2="55" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF6B6B" />
        <stop offset="0.5" stopColor="#E4002B" />
        <stop offset="1" stopColor="#8B0000" />
      </linearGradient>
    </defs>
  </svg>
)

export const StarIcon = ({ className = '', size = 40, color = '#FFD700' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 2L24.5 14.5H38L27 23L31.5 38L20 28.5L8.5 38L13 23L2 14.5H15.5L20 2Z" fill={color} />
  </svg>
)

export const SparkleIcon = ({ className = '', size = 30 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 0L17 13L30 15L17 17L15 30L13 17L0 15L13 13L15 0Z" fill="#FFD700" />
  </svg>
)

export const LeafIcon = ({ className = '', size = 50 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25 45C25 45 5 35 5 20C5 5 25 5 25 5C25 5 45 5 45 20C45 35 25 45 25 45Z" fill="#228B22" />
    <path d="M25 10V40M15 20C20 20 25 25 25 30M35 20C30 20 25 25 25 30" stroke="#90EE90" strokeWidth="2" />
  </svg>
)

export const BowlIcon = ({ className = '', size = 80 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="40" cy="35" rx="35" ry="10" fill="#E4002B" />
    <path d="M5 35C5 35 10 70 40 70C70 70 75 35 75 35" stroke="#E4002B" strokeWidth="8" fill="none" />
    <ellipse cx="40" cy="35" rx="30" ry="7" fill="#FFF5E6" />
    {/* Food in bowl */}
    <circle cx="30" cy="33" r="5" fill="#D2691E" />
    <circle cx="45" cy="32" r="6" fill="#8B4513" />
    <circle cx="38" cy="36" r="4" fill="#228B22" />
  </svg>
)

export const CheckIcon = ({ className = '', size = 40 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="18" fill="#61CE70" />
    <path d="M12 20L18 26L28 14" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const LocationIcon = ({ className = '', size = 40 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 2C12 2 6 8 6 16C6 26 20 38 20 38C20 38 34 26 34 16C34 8 28 2 20 2Z" fill="#E4002B" />
    <circle cx="20" cy="16" r="6" fill="white" />
  </svg>
)

export const PhoneIcon = ({ className = '', size = 40 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 5C8 5 10 3 14 3C18 3 20 5 20 10V12C20 12 28 14 32 20C36 26 37 32 37 32C37 36 35 38 32 38C28 38 20 35 14 28C8 21 5 14 5 10C5 6 7 5 8 5Z" fill="#E4002B" />
  </svg>
)

export const EmailIcon = ({ className = '', size = 40 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="8" width="34" height="24" rx="3" fill="#E4002B" />
    <path d="M3 11L20 22L37 11" stroke="white" strokeWidth="2" />
  </svg>
)

export const ClockIcon = ({ className = '', size = 40 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="17" stroke="#E4002B" strokeWidth="3" fill="white" />
    <path d="M20 10V20L26 26" stroke="#E4002B" strokeWidth="3" strokeLinecap="round" />
  </svg>
)

export const UserIcon = ({ className = '', size = 100, color = '#E4002B' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="48" fill="#F5F5F5" stroke={color} strokeWidth="2" />
    <circle cx="50" cy="38" r="18" fill={color} />
    <path d="M20 85C20 65 32 55 50 55C68 55 80 65 80 85" fill={color} />
  </svg>
)
